/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompiledReportCellText } from './compiledReportCellText';
import { CompiledReportCellImage } from './compiledReportCellImage';
import { CompiledReportCellChart } from './compiledReportCellChart';
import { CompiledReportCellTable } from './compiledReportCellTable';


export interface CompiledReportCell {
    chart?: CompiledReportCellChart;
    combinedImages?: Array<CompiledReportCellImage>;
    image?: CompiledReportCellImage;
    table?: CompiledReportCellTable;
    text?: CompiledReportCellText;
}

